import React, {useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {useLocation} from "react-router-dom";
import propTypes from 'prop-types';

import {CleanButton} from "../../components/index";
import {getNumeroRecordPerPagina, getStateFormCorsi} from "./utilityFunctionCorsi/utilityFunctionCorsi";
import {corso_corsiActions} from "../../actions";
import {dayJS, RUOLI} from "../../applicationConf";


export const FormSearchCorsi = React.forwardRef((props, ref) => {

    const [searchCorsiForm, setSearchCorsiForm] = useState({...getStateFormCorsi()});
    const [flagCourseAvailable, setFlagCourseAvailable] = useState(true);
    const {pathname} = useLocation();

    const dispatch = useDispatch();

    const getCorsiSearch = React.useCallback((paramRicerca) => dispatch(corso_corsiActions.getCorsiSearch(paramRicerca)), [dispatch]);

    const ruoloScelto = useSelector(state => state.auth.ruoloScelto);


    React.useEffect(() => {
        if (!pathname.startsWith(RUOLI.SYSTEMADMIN.SUPER_ADMIN.CONTEXT_ROUTES)) {
            onSearch(1);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onSearch = React.useCallback((pageNumber) => {
        const _searchCorsiForm = {...searchCorsiForm};

        _searchCorsiForm.numeroPagina = pageNumber;
        props.changeActivePage(pageNumber);

        setSearchCorsiForm(_searchCorsiForm);
        getCorsiSearch(Object.assign({},
            _searchCorsiForm,
            {
            numeroRecordPerPagina: getNumeroRecordPerPagina(),
            dataRicerca: _searchCorsiForm.dataRicerca === '' ? null : _searchCorsiForm.dataRicerca
        }));
    }, [getCorsiSearch, props, searchCorsiForm]);

    const handlerChange = ({target}) => {
        const _searchCorsiForm = {...searchCorsiForm};

        // non permette l'inserimento di stringa vuota o spazio nel campo codice
        let value = target.value === '' ? null : target.value.toUpperCase();
        if (target.id === 'codice' && value) {
            value = value.replace(/\s+/g, '');
        }
        _searchCorsiForm[target.id] = value;
        setSearchCorsiForm(_searchCorsiForm);
    };

    const sendValue = (event) => {
        event.preventDefault();
        event.stopPropagation();
        onSearch(1);
    };

    const cleanField = () => {
        setSearchCorsiForm({...getStateFormCorsi()});
        setFlagCourseAvailable(true);
    };

    React.useImperativeHandle(ref,
        () => ({
            searchCorsi: (pageNumber) => onSearch(pageNumber)
        }));

    return (
        <form id="formRicerca" className="form-group " autoComplete={'off'} data-test='component-formSearchCorsi'>
            <div className='d-flex justify-content-md-center justify-content-lg-center mb-3'>
                <div className='col-md-12 col-lg-8'>
                    <div className="row">
                        <div className="col-sm-12 col-md-3 col-lg-3 mt-2">
                            <label htmlFor="codice">
                                Codice:
                            </label>
                            <input id="codice"
                                   placeholder="Codice"
                                   maxLength={50}
                                   type="text"
                                   value={searchCorsiForm.codice ? searchCorsiForm.codice : ''}
                                   className="form-control"
                                   onChange={handlerChange}
                            />
                        </div>
                        <div className="col-sm-12 col-md-9 col-lg-9 mt-2">
                            <label htmlFor="descrizione">
                                Descrizione:
                            </label>
                            <input id="descrizione"
                                   placeholder="Descrizione"
                                   type="text"
                                   value={searchCorsiForm.descrizione ? searchCorsiForm.descrizione : ''}
                                   className="form-control"
                                   onChange={handlerChange}
                            />
                        </div>
                    </div>

                    {RUOLI[ruoloScelto.toUpperCase()].EXTEND_COUSES_SEARCH && (
                        <div className="row">
                            <div className="col-sm-12 col-md-3 col-lg-3 mt-2">
                                <label htmlFor="codiceFiscaleEnte">
                                    Codice fiscale ente:
                                </label>
                                <input id="codiceFiscaleEnte"
                                       placeholder="Codice fiscale ente"
                                       maxLength={16}
                                       type="text"
                                       value={searchCorsiForm.codiceFiscaleEnte ? searchCorsiForm.codiceFiscaleEnte : ''}
                                       className="form-control"
                                       onChange={handlerChange}
                                />
                            </div>
                            <div className="col-sm-12 col-md-9 col-lg-9 mt-2">
                                <label htmlFor="denominazioneEnte">
                                    Denominazione ente:
                                </label>
                                <input id="denominazioneEnte"
                                       placeholder="Denominazione ente"
                                       type="text"
                                       value={searchCorsiForm.denominazioneEnte ? searchCorsiForm.denominazioneEnte : ''}
                                       className="form-control"
                                       onChange={handlerChange}
                                />
                            </div>
                        </div>
                    )}

                    <div className='row'>
                        <div className='col-12'>
                            <div className='row align-items-center'>
                                <div className="col-sm-12 col-md-3 col-lg-3 mt-3">
                                    <label htmlFor='flagCourseAvailable' style={{marginRight: '30px', marginBottom: 0}}>
                                        Visualizza alla data:
                                    </label>
                                    <input type="checkbox"
                                           id='flagCourseAvailable'
                                           checked={flagCourseAvailable}
                                           onChange={() => {
                                               const dataRicerca = !flagCourseAvailable ? dayJS().format('YYYY-MM-DD') : ''
                                               setSearchCorsiForm(prevState => ({...prevState, dataRicerca}))
                                               setFlagCourseAvailable(!flagCourseAvailable);
                                           }}
                                    />
                                </div>
                                <div className="col-sm-12 col-md-9 col-lg-9 mt-3">
                                    <label htmlFor="dataRicerca" className=" form-control-label">
                                        Corsi attivi alla data:
                                    </label>
                                    <input id="dataRicerca" type="date"
                                           value={searchCorsiForm.dataRicerca}
                                           className="form-control text-center" onChange={handlerChange}
                                           disabled={!flagCourseAvailable}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br/>
            <div className='row justify-content-md-center justify-content-lg-center'>
                <div className='col-sm-12 col-md-8 col-lg-5'>
                    <div className='row justify-content-md-between justify-content-lg-between'>
                        <button type="submit"
                                className="btn btn-primary col-sm-12 col-md-5 col-lg-5 btn-sm shadow"
                                style={{fontSize: '20px', marginBottom: '20px'}}
                                onClick={sendValue}>
                            Cerca
                        </button>
                        <CleanButton text="Pulisci" cleanField={cleanField}
                                     styles={{fontSize: '20px', marginBottom: '20px'}}
                                     classes="btn btn-primary col-sm-12 col-md-5 col-lg-5 btn-sm shadow"/>
                    </div>
                </div>
            </div>
        </form>
    )
});

FormSearchCorsi.propTypes = {
    changeActivePage: propTypes.func.isRequired
};



